import { useMemo } from 'react';
import type { Action } from './types';
import { ActionRegistry } from './ActionRegistry';

/**
 * Provides action dispatcher and registry instance.
 */
export const useActions = (): {
  /* Dispatches an action */
  dispatch: (action: Action) => void;
  registry: ActionRegistry;
} => {
  const registry = useMemo(() => ActionRegistry.getInstance(), []);

  return useMemo(() => ({ dispatch: registry.dispatch, registry }), [registry]);
};
